import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

const RadioInput = ({ label, asterisk, value, onChange, options }) => {
	return (
		<Box display="block">
			<Typography variant="overline" display="block">
				{label}
				{asterisk ? (
					<Typography
						variant="overline"
						sx={{ color: "red", fontWeight: "bold" }}
					>
						*
					</Typography>
				) : null}
			</Typography>
			<FormControl>
				<RadioGroup row value={value} onChange={onChange}>
					{options.map((option) => {
						return (
							<FormControlLabel
								key={option.label}
								value={option.value}
								control={<Radio />}
								label={option.label}
							/>
						);
					})}
				</RadioGroup>
			</FormControl>
		</Box>
	);
};

export default RadioInput;
